import { getMimeTypeFromFilename } from '../../../utils';
import { getFileAttributes } from '../..';
export var createZipEntryLoadSucceededEvent = function createZipEntryLoadSucceededEvent(fileState, zipEntry) {
  var _getFileAttributes = getFileAttributes(fileState),
    fileId = _getFileAttributes.fileId,
    fileMediatype = _getFileAttributes.fileMediatype,
    fileMimetype = _getFileAttributes.fileMimetype,
    fileSize = _getFileAttributes.fileSize,
    fileStatus = _getFileAttributes.fileStatus;
  return {
    eventType: 'operational',
    actionSubject: 'mediaFile',
    action: 'zipEntryLoadSucceeded',
    attributes: {
      status: 'success',
      fileAttributes: {
        fileId: fileId,
        fileMediatype: fileMediatype,
        fileMimetype: fileMimetype,
        fileSize: fileSize,
        fileStatus: fileStatus
      },
      size: zipEntry.size,
      encrypted: zipEntry.encrypted,
      compressedSize: zipEntry.compressedSize,
      mimeType: getMimeTypeFromFilename(zipEntry.name)
    }
  };
};